
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'badges': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.49318 0H5.22614V0.75C5.22614 1.164 5.56061 1.5 5.97273 1.5H8.95909C9.37121 1.5 9.70568 1.164 9.70568 0.75V0H13.4386C14.2636 0 14.9318 0.67125 14.9318 1.5V16.5C14.9318 17.3288 14.2636 18 13.4386 18H1.49318C0.668199 18 0 17.3288 0 16.5V1.5C0 0.67125 0.668199 0 1.49318 0ZM7.44138 4.05584C5.58999 4.05584 4.08915 5.55669 4.08915 7.40807V11.5975C4.08915 13.4489 5.58999 14.9497 7.44138 14.9497C9.29276 14.9497 10.7936 13.4489 10.7936 11.5975V7.40807C10.7936 5.55669 9.29276 4.05584 7.44138 4.05584ZM8.4 8.1C8.4 7.60294 7.99706 7.2 7.5 7.2C7.00294 7.2 6.6 7.60294 6.6 8.1V10.8C6.6 11.2971 7.00294 11.7 7.5 11.7C7.99706 11.7 8.4 11.2971 8.4 10.8V8.1Z"/>'
  }
})
